export class InvalidRequestDataException extends Error {
  constructor(message) {
    super(message);
  }
}

